import React from 'react';

export const DEFAULT_PAGE = 0;
export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

export type PaginationContextValue = {
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  onModelChange: (page: number, rowsPerPage: number) => void;
  resetPage: () => void;
};

export const PaginationContext = React.createContext<PaginationContextValue>({
  page: DEFAULT_PAGE,
  rowsPerPage: DEFAULT_ROWS_PER_PAGE,
  rowsPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS,
  onModelChange: () => {},
  resetPage: () => {},
});
